/**
 * cart-popup.js — standalone (no @theme/* imports)
 * Événement 'cart:update' = ThemeEvents.cartUpdate (assets/events.js)
 */
(function () {
  'use strict';

  var CART_EVENT = 'cart:update';
  var prevCount  = 0;
  var popup      = null;

  popup = document.querySelector('cart-popup-component');
  if (!popup) return;

  var closeBtn = popup.querySelector('[data-popup-action="close"]');

  /* ── Config depuis data-attributes ── */
  var freeShippingThreshold  = parseInt(popup.dataset.freeShipping || '5000', 10);
  var textRemaining  = popup.dataset.shippingTextRemaining  || 'Il ne manque plus que {amount} pour la livraison gratuite';
  var colorRemaining = popup.dataset.shippingColorRemaining || 'rgba(0,0,0,.55)';
  var textDone       = popup.dataset.shippingTextDone       || '🎉 Livraison gratuite débloquée !';
  var colorDone      = popup.dataset.shippingColorDone      || '#22a06b';

  /* ── Snapshot du nombre d'articles ── */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (c) { prevCount = c.item_count; })
    .catch(function () {});

  /* ── Écoute cart:update ── */
  document.addEventListener(CART_EVENT, function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count <= prevCount) {
          prevCount = cart.item_count;
          return;
        }
        prevCount = cart.item_count;
        if (!cart.items || !cart.items.length) return;
        populate(cart.items[0], cart.item_count, cart.total_price);
        open();
      })
      .catch(function (e) { console.error('[CartPopup]', e); });
  });

  /* ── Fermeture ── */
  function close() {
    popup.dataset.open = 'false';
    document.body.style.overflow = '';
  }

  if (closeBtn)    closeBtn.addEventListener('click', close);
  var overlay      = popup.querySelector('.cart-popup__overlay');
  var btnContinue  = popup.querySelector('[data-popup-action="continue"]');
  if (overlay)     overlay.addEventListener('click', close);
  if (btnContinue) btnContinue.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.dataset.open === 'true') close();
  });

  /* ── Remplissage ── */
  function populate(item, total, totalPrice) {
    var img     = popup.querySelector('[data-popup-slot="image"]');
    var titleEl = popup.querySelector('[data-popup-slot="title"]');
    var varEl   = popup.querySelector('[data-popup-slot="variant"]');
    var priceEl = popup.querySelector('[data-popup-slot="price"]');
    var countEl = popup.querySelector('[data-popup-slot="cart-count"]');

    if (img) {
      var src = (item.featured_image && item.featured_image.url) || item.image || '';
      img.src = src.replace(/(\.[^.?]+)(\?.*)?$/, '_160x160$1$2');
      img.alt = item.product_title || '';
    }
    if (titleEl) titleEl.textContent = item.product_title || '';
    if (varEl) {
      var hasVar = item.variant_title && item.variant_title !== 'Default Title';
      varEl.textContent = hasVar ? item.variant_title : '';
      if (hasVar) varEl.removeAttribute('hidden'); else varEl.setAttribute('hidden', '');
    }
    if (priceEl) {
      priceEl.textContent = (item.final_price / 100).toLocaleString('fr-FR', { minimumFractionDigits:2, maximumFractionDigits:2 }) + ' €';
    }
    if (countEl) {
      countEl.textContent = total === 1 ? '1 article dans votre panier' : total + ' articles dans votre panier';
    }

    /* ── Livraison gratuite ── */
    var shippingWrap = popup.querySelector('[data-popup-slot="shipping-wrap"]');
    var shippingFill = popup.querySelector('[data-popup-slot="shipping-fill"]');
    var shippingText = popup.querySelector('[data-popup-slot="shipping-text"]');

    if (shippingWrap && shippingText) {
      var remaining = freeShippingThreshold - totalPrice;
      if (remaining <= 0) {
        if (shippingFill) shippingFill.style.width = '100%';
        shippingText.textContent = textDone;
        shippingText.style.color = colorDone;
      } else {
        var pct = Math.min(100, Math.round((totalPrice / freeShippingThreshold) * 100));
        if (shippingFill) shippingFill.style.width = pct + '%';
        var remainEuros = (remaining / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        shippingText.textContent = textRemaining.replace('{amount}', remainEuros + ' €');
        shippingText.style.color = colorRemaining;
      }
      shippingWrap.removeAttribute('hidden');
    }
  }

  /* ── Ouverture ── */
  function open() {
    popup.dataset.open = 'true';
    document.body.style.overflow = 'hidden';
    if (closeBtn) requestAnimationFrame(function () { closeBtn.focus(); });
  }

})();
